import React, { ReactNode, useEffect } from 'react';
import { useToast } from '@loglass/loglass-ui/toast';
import { Role } from '~/common/providers/auth/role';
import { useRoleGuard } from '~/common/providers/auth/use-role-guard';

type Props = {
  allowedRoles: Role[];
  withErrorToast?: boolean;
  children: ReactNode;
};

// TODO: RoleGuard をすべて Replace したら、RoleGuard に Rename すること
const NewRoleGuard: React.FC<Props> = React.memo(function RoleGuard({
  allowedRoles,
  children,
  withErrorToast,
}) {
  const { addToast } = useToast();
  const permitted = useRoleGuard(allowedRoles);

  useEffect(() => {
    if (withErrorToast != null && !permitted) {
      addToast({
        text: 'この機能にアクセスする権限がありません。管理者にお問い合わせください',
        type: 'error',
      });
    }
  }, [withErrorToast, addToast, permitted]);

  return <>{permitted && children}</>;
});

export { NewRoleGuard };
